import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectUsers, selectLoaded, selectLoading, selectLookupLoaded, selectLookupOptions, selectTotal } from '../selectors/users.selector';
import { usersActions } from '../actions/users.actions';
import { GetUsersValue } from '../models';

@Service()
export class UsersFacade {
    private readonly store = inject(Store);

    readonly users = this.store.selectSignal(selectUsers);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly total = this.store.selectSignal(selectTotal);
    readonly lookupLoaded = this.store.selectSignal(selectLookupLoaded);
    readonly lookupOptions = this.store.selectSignal(selectLookupOptions);

    getUsers(value: GetUsersValue): void {
        this.store.dispatch(usersActions.getUsers({ value }));
    }

    getUsersLookup(): void {
        this.store.dispatch(usersActions.getUsersLookup());
    }

    clear(): void {
        this.store.dispatch(usersActions.clear());
    }
}
